import { useEffect, useState } from 'react';
import * as yup from 'yup';
import { AssignClient } from 'components/shared/ClientConsultantsAssignement/AssignClient';
import {
  CustomAutocomplete,
  CustomAutocompleteFreeSolo,
} from 'components/shared/DropDown/CustomAutocomplete';
import { CustomChipsAutocomplete } from 'components/shared/DropDown/CustomChipsAutocomplete';
import { UpDownInputArrows } from 'components/shared/UpDownInputArrows';
import { useHistory } from 'react-router-dom';

import ErrorSuccesModal from 'components/shared/modal/ErrorSuccesModal';
import { useTranslation } from 'react-i18next';
import { ROLES } from 'utils/Constants';
import axiosPixLink from 'config/axiosPixLink';
import { AssignConsultant } from 'components/shared/ClientConsultantsAssignement/AssignConsultant';
import { Loader } from 'components/shared/Loader';
import LanguageCheckBoxGroup from 'components/Netlinking/CheckBox/LanguageCheckBox';
import { LanguageSearchField } from 'components/Netlinking/AutoComplete/languageAutoComplete';
import { getLanguageIdByName } from 'utils/netlinking/languages';

const API = {
  pixopClients: '/user/pixOpsClient',
  getAllConsultants: '/user/consultants',
  getAllSuperConsultants: 'user/superconsultants',
  getAllClients: '/user/clients',
  getAvailableThematics: '/netlinking/all-thematics',
  createWebsite: '/website/create',
};

export default function SuperAdminCreateWebsite() {
  const history = useHistory();
  const { t } = useTranslation();
  const [pixOpData, setPixOpData] = useState([]);
  const [disabledForm, setDisabledForm] = useState(true);

  const [accountsList, setAccountsList] = useState([]);
  const [account, setAccount] = useState(null);

  const [urlSitesList, setUrlSitesList] = useState([]);

  const [urlSite, setUrlSite] = useState(null);
  const [urlWebsite, setUrlWebsite] = useState(null);

  const [consultant, setConsultant] = useState(null);
  const [consultantsList, setConsultantsList] = useState([]);
  const [superConsultantsList, setSuperConsultantsList] = useState([]);

  const [clientsList, setClientsList] = useState([]);
  const [netlinkingLanguage, setNetlinkingLanguage] = useState('');

  const [availableThematicsList, setAvailableThematicsList] = useState([]);
  const [websiteThematics, setWebsiteThematics] = useState([]);

  const [serviceDetails, setServiceDetails] = useState('');

  const [coconsTextNbr, setCoconsTextNbr] = useState(0);
  const [coconsNbr, setCoconsNbr] = useState(0);
  const [faqNbr, setFaqNbr] = useState(0);
  const [gmbNbr, setGmbNbr] = useState(0);
  const [textOptimizerNbr, setTextOptimizerNbr] = useState(0);
  const [loader, setLoader] = useState(false);

  const validationSchema = yup.object().shape({
    coconsTextNbr: yup.number().min(0).required(),
    coconsNbr: yup.number().min(0).required(),
    faqNbr: yup.number().min(0).required(),
    gmbNbr: yup.number().min(0).required(),
    textOptimizerNbr: yup.number().min(0).required(),
  });

  const [assignedClients, setAssignedClients] = useState([
    {
      name: '',
      email: '',
      phoneNumber: '',
      isNew: false,
    },
  ]);

  const [assignedConsultants, setAssignedConsultants] = useState([
    {
      name: '',
      firstName: '',
      lastName: '',
      isNew: false,
    },
  ]);
  const [assignedSuperConsultants, setAssignedSuperConsultants] = useState([
    {
      name: '',
      firstName: '',
      lastName: '',
      isNew: false,
    },
  ]);

  const [errorSuccess, setErrorSuccess] = useState(false);
  const [errorSuccessMsg, setErrorSuccessMsg] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    window.dispatchEvent(new Event('locationchange'));
    axiosPixLink.get(API.pixopClients).then((res) => {
      setPixOpData(res.data);
      setAccountsList(res.data.map((x) => x.clientName));
    });

    axiosPixLink.get(API.getAllConsultants).then((res) => {
      setConsultantsList(res.data);
    });
    axiosPixLink.get(API.getAllSuperConsultants).then((res) => {
      setSuperConsultantsList(res.data);
    });

    axiosPixLink
      .get(API.getAvailableThematics)
      .then((res) => setAvailableThematicsList(res.data));
  }, []);

  useEffect(() => {
    // setUrlSite(undefined);

    if (account) {
      if (pixOpData.length > 0) {
        if (account && account?.length > 0) {
          axiosPixLink.get(`/website/${account}/getUrlSite`).then((res) => {
            setUrlSitesList([
              ...res.data,
              ...pixOpData.find((x) => x.clientName === account).site,
            ]);
          });
        }
      }
      axiosPixLink
        .get(API.getAllClients, { params: { account: account } })
        .then((res) => {
          setClientsList(res.data);
        });
    }
    setUrlSite('');
    setConsultant(null);
    setCoconsTextNbr('');
    setCoconsNbr('');
    setTextOptimizerNbr('');
    setFaqNbr('');
    setGmbNbr('');
  }, [account, pixOpData]);

  useEffect(() => {
    const checkValidForm = async () => {
      const invalidClients = assignedClients.some((x) => !x.email);
      const invalidConsultants = assignedConsultants.some(
        (x) =>
          !x.firstName ||
          !x.lastName ||
          !x.email ||
          !x.firstName.length ||
          !x.lastName.length ||
          !x.email.length
      );
      const invalidSuperConsultants = assignedSuperConsultants.some(
        (x) =>
          !x.firstName ||
          !x.lastName ||
          !x.email ||
          !x.firstName.length ||
          !x.lastName.length ||
          !x.email.length
      );

      if (
        !account ||
        !urlWebsite ||
        !netlinkingLanguage ||
        websiteThematics.length === 0 ||
        invalidClients ||
        invalidSuperConsultants
      ) {
        setDisabledForm(true);
      } else {
        setDisabledForm(false);
      }
    };
    checkValidForm();
  }, [
    urlSite,
    account,
    netlinkingLanguage,
    consultant,
    websiteThematics,
    serviceDetails,
    assignedClients,
    validationSchema,
    coconsTextNbr,
    coconsNbr,
    faqNbr,
    gmbNbr,
    textOptimizerNbr,
  ]);

  const callbackFromMultiSelect = (newList) => {
    setWebsiteThematics(newList);
  };

  function handleLanguageChange(newLanguage) {
    setNetlinkingLanguage(newLanguage);
  }

  const createWebsite = () => {
    setLoader(true);
    const filteredAssignedSuperConsultants = assignedSuperConsultants.filter(
      (item) => item.email !== ''
    );
    const filteredAssignedConsultants = assignedConsultants.filter(
      (item) => item.email !== ''
    );

    const body = {
      account: account,
      urlWebsite: urlWebsite,
      thematics: websiteThematics,
      clients: assignedClients,
      superConsultants: filteredAssignedSuperConsultants,
      consultants: filteredAssignedConsultants,
      languageId: getLanguageIdByName(netlinkingLanguage),
      serviceDetails: serviceDetails,
    };

    axiosPixLink
      .post(API.createWebsite, body)
      .then(() => {
        setIsSuccess(true);
        setErrorSuccessMsg(
          `${t('Le contrat pour le client')} ${account}  ${t(
            'a été créé avec succès'
          )}!`
        );
        setLoader(false);
        setErrorSuccess(true);
      })
      .catch((e) => {
        setIsSuccess(false);

        setErrorSuccessMsg(
          e.response.status === 409
            ? `Un client existe déjà avec cette URL de site web : ${urlWebsite}`
            : e.response.status === 411
              ? 'On ne peut pas créer un nouveau client contact avec un mail existant'
              : t("Oups....! Une erreur s'est produite")
        );
        setLoader(false);
        setErrorSuccess(true);
      });
    setLoader(false);
  };

  return (
    <div className="content-center">
      <div className="box-header-top header-info">
        <span onClick={history.goBack} className="bt-circle me-3" />
        <h1>{t('Nouveau client')}</h1>
      </div>
      {loader && <Loader />}
      <div className="row">
        <div className="col-12 col-md-10 box-screen">
          <div className="box-img-bg bg-8" />
          <div className="box-img-bg bg-7" style={{ zIndex: -1 }} />
          <div className="box-img-bg bg-9" />
          <div className="header-title">{t('Fiche du site web')} </div>
          <div className="box-wrapper">
            <div className="row">
              <div className="col-12 col-md-12">
                <div className="row row-mb">
                  <div className="col-12 col-md-4">
                    <div className="label-title">{t('Compte client')}* </div>
                    <CustomAutocomplete
                      disabled={accountsList.length <= 0}
                      list={accountsList}
                      value={account || ''}
                      setValue={(value) => setAccount(value)}
                      getOptionSelected={(option) => option === account}
                      getOptionDisabled={(option) => false}
                      getOptionLabel={(option) => {
                        return option;
                      }}
                    />
                  </div>
                  <div className="col-12 col-md-4">
                    <div className="label-title">{t('Url du site')}*</div>

                    <CustomAutocompleteFreeSolo
                      list={urlSitesList}
                      value={urlSite}
                      getOptionSelected={(option) => option === urlSite}
                      onInputChange={(value) => {
                        if (typeof value?.target?.value === 'string') {
                          setUrlWebsite(value?.target?.value);
                        } else {
                          setUrlWebsite(value);
                        }
                        /*setUrlSite(value);*/
                      }}
                      setValue={(option) => {
                        setUrlSite(option);
                        setUrlWebsite(option);
                      }}
                      getOptionLabel={(option) => {
                        return option;
                      }}
                    />
                  </div>
                </div>
                <div className="row row-mb">
                  <div className="col-12 col-md-2">
                    <div className="label-title">{t('Langue')}*</div>
                    <div>
                      <LanguageSearchField
                        onLanguageChange={handleLanguageChange}
                      ></LanguageSearchField>
                    </div>
                  </div>
                </div>
                {assignedClients.map((client, index) => (
                  <AssignClient
                    id={index}
                    list={clientsList.filter(
                      (item) =>
                        !assignedClients.some(
                          (item2) => item2.email === item.email
                        )
                    )}
                    new={true}
                    data={client}
                    account={account}
                    key={index}
                    addClient={() =>
                      setAssignedClients([
                        ...assignedClients,
                        {
                          name: '',
                          firstName: '',
                          lastName: '',
                          email: '',
                          phoneNumber: '',
                        },
                      ])
                    }
                    updateClientsList={(type, object) => {
                      const newValue = client;
                      newValue[type] = object;
                      const newList = assignedClients;
                      newList[index] = newValue;
                      setAssignedClients([...newList]);
                    }}
                    isDeleteable={assignedClients.length > 1}
                    deleteClient={(index) => {
                      let newList = assignedClients;
                      newList.splice(index, 1);
                      setAssignedClients([...newList]);
                    }}
                  />
                ))}

                {assignedSuperConsultants.map((consultant, index) => (
                  <AssignConsultant
                    entityName={'Super Consultant*'}
                    consultant={consultant}
                    id={index}
                    consultantsList={superConsultantsList.filter(
                      (item) =>
                        !assignedSuperConsultants.some(
                          (item2) => item2.email === item.email
                        )
                    )}
                    new={true}
                    data={consultant}
                    account={account}
                    key={index}
                    addConsultant={() =>
                      setAssignedSuperConsultants([
                        ...assignedSuperConsultants,
                        {
                          isNew: false,
                          email: '',
                          firstName: '',
                          lastName: '',
                        },
                      ])
                    }
                    updateConsultantList={(type, object) => {
                      const newValue = consultant;
                      newValue[type] = object;
                      const newList = assignedSuperConsultants;
                      newList[index] = newValue;
                      setAssignedSuperConsultants([...newList]);
                    }}
                    isDeleteable={assignedSuperConsultants.length > 1}
                    deleteConsultant={(index) => {
                      let newList = assignedSuperConsultants;
                      newList.splice(index, 1);
                      setAssignedSuperConsultants([...newList]);
                    }}
                  />
                ))}

                {assignedConsultants.map((consultant, index) => (
                  <AssignConsultant
                    entityName={'Consultant'}
                    consultantsList={consultantsList.filter(
                      (item) =>
                        !assignedConsultants.some(
                          (item2) => item2.email === item.email
                        )
                    )}
                    consultant={consultant}
                    setValue={(option) => setConsultant(option)}
                    id={index}
                    list={consultantsList.filter(
                      (item) =>
                        !consultantsList.some(
                          (item2) => item2.email === item.email
                        )
                    )}
                    new={true}
                    data={consultant}
                    account={account}
                    key={index}
                    addConsultant={() =>
                      setAssignedConsultants([
                        ...assignedConsultants,
                        {
                          email: '',
                          firstName: '',
                          lastName: '',
                        },
                      ])
                    }
                    updateConsultantList={(type, object) => {
                      const newValue = consultant;
                      newValue[type] = object;
                      const newList = assignedConsultants;
                      newList[index] = newValue;
                      setAssignedConsultants([...newList]);
                    }}
                    isDeleteable={assignedConsultants.length > 1}
                    deleteConsultant={(index) => {
                      let newList = assignedConsultants;
                      newList.splice(index, 1);
                      setAssignedConsultants([...newList]);
                    }}
                  />
                ))}

                <div className="row">
                  <div className="col-12 col-md-7">
                    <div className="label-title">
                      {t('Thématiques d’expertise')}*
                    </div>
                    <CustomChipsAutocomplete
                      callbackFromMultiSelect={callbackFromMultiSelect}
                      value={websiteThematics}
                      disabled={!availableThematicsList}
                      list={availableThematicsList}
                      setValue={(option) => setWebsiteThematics(option)}
                      getOptionLabel={(option) => {
                        return t(option.theme) || '';
                      }}
                    />
                  </div>
                  <div className="col-12 col-md-5">
                    <div className="label-title">
                      {t('Détail de la prestation')}
                    </div>
                    <div>
                      <input
                        type="text"
                        className="form-control form-ct"
                        value={serviceDetails}
                        disabled={false}
                        onChange={(e) => setServiceDetails(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="box-button-bt">
            <div>
              {disabledForm ? (
                <button className="bt-submit-disabled-y">
                  {' '}
                  {t('Sauvegarder')}{' '}
                </button>
              ) : (
                <button className="bt-submit-y" onClick={createWebsite}>
                  {t('Sauvegarder')}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <ErrorSuccesModal
        open={errorSuccess}
        message={errorSuccessMsg}
        handleClose={() =>
          isSuccess ? history.push('/') : setErrorSuccess(false)
        }
        toggle={() => setErrorSuccess(!errorSuccess)}
        success={isSuccess}
      />
    </div>
  );
}
